export const navigateUrl = (url: string): void => {
    const element = document.createElement('a');
    if(url.startsWith('http://') || url.startsWith('https://')){
      element.href =  url;
    } else{
      element.href = 'http://' + url;
    }
    element.click();
}